/**
 * Copyright Mántum All Rights Reserved.
 */
export const KEY_ERROR_STATUS = 'Error';
export const KEY_WARNING_STATUS = 'Warning';
